<template>
    <div class="login">
        <div class="row row--fullwidth">
            <div class="col lg-6 sm-12">
                <div class="login-form">
                    <div class="login-form__title text_15 text_bold">{{ $t("register") }}</div>
                    <form>
                        <div class="form-group" v-for="(input, name, inputIndex) in form" :key="inputIndex">
                            <Input
                                :inputClass="input.inputClass"
                                :isValid="input.required ? input.isValid : true"
                                :validationMessage="input.required ? input.validationMessage : ''"
                                :type="input.type"
                                :name="name"
                                :label="input.label"
                                :labelDescription="input.labelDescription"
                                :required="input.required"
                                :cleaveOptions="input.cleaveOptions"
                                v-model="input.value"
                                :suggestion="input.suggestion"
                                :mask="input.mask" />
                        </div>
                        <transition name="fade">
                            <div class="error text_11" v-if="error">{{ error }}</div>
                        </transition>
                        <div class="form-group login-submit">
                            <div class="button button--dark button--wide" @click="submitForm">
                                {{ $t("register") }}
                            </div>
                            <nuxt-link :to="{ name: 'lk-login', query: $route.query }" class="button button--text"
                                >{{ $t("lk_log_in") }}
                            </nuxt-link>
                        </div>
                        <div class="text_9">
                            <span class="color-text_2">{{ $t("terms_register") }}</span>
                            <nuxt-link to="/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/"
                                >{{ $t("terms_po_pp") }}
                            </nuxt-link>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col lg-6 sm-12 col--no-padding login-img">
                <UiImage :path="img" :desktop="{ width: 1016 }" :lazy="false" />
            </div>
        </div>
    </div>
</template>
<script>
import Input from "~/components/form/Input";
import { mapGetters } from "vuex";
import UiImage from "../../components/ui/Image.vue";

export default {
    name: "Regster",
    components: {
        UiImage,
        Input,
    },
    async asyncData({ $axios }) {
        try {
            return {
                img: (await $axios.get("/api/page-images/register")).data.img,
            };
        } catch (e) {
            console.log(e);
        }
    },
    data() {
        return {
            error: "",
            form: {
                name: {
                    label: this.$i18n.t("yr_name"),
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                    inputClass: "black-border",
                },
                email: {
                    label: this.$i18n.t("el_mail"),
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                    inputClass: "black-border",
                },
                subscribed: {
                    type: "checkbox",
                    label: this.$i18n.t("subscribe"),
                    value: 1,
                },
                phone: {
                    label: this.$i18n.t("phone"),
                    type: "tel2",
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: this.$auth.loggedIn && this.$auth.user.phone ? this.$auth.user.phone : null,
                    inputClass: "black-border",
                    mask: "+7 (###) ###-##-##",
                },
                password: {
                    label: this.$i18n.t("make_password"),
                    type: "password",
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                    inputClass: "black-border",
                },
            },
            img: null,
        };
    },
    watch: {
        async langust() {
            this.$store.commit("crumbs/change", this.crumbs);
            this.form.name.label = this.$i18n.t("yr_name");
            this.form.email.label = this.$i18n.t("el_mail");
            this.form.subscribed.label = this.$i18n.t("subscribe");
            this.form.phone.label = this.$i18n.t("phone");
            this.form.password.label = this.$i18n.t("make_password");
        },
        currentCountry() {
            this.form.phone.value = this.$auth.loggedIn && this.$auth.user.phone ? this.$auth.user.phone : null;
        },
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
            currentCountry: "globalvars/getCurrentCountry",
            currentCountryPhoneCode: "globalvars/getCurrentCountryPhoneCode",
        }),
        crumbs() {
            return [
                {
                    name: this.$i18n.t("register"),
                },
            ];
        },
    },
    methods: {
        submitForm() {
            for (const key in this.form) {
                if (Object.hasOwnProperty.call(this.form, key)) {
                    const element = this.form[key];
                    element.isValid = true;
                    element.validationMessage = "";
                }
            }

            let tags = [];
            if (this.$route.query.source === "popup") {
                tags = ["регистрация с сайта"];
            }

            this.$axios.get("/api/auth/xsrf_token").then(async () => {
                try {
                    let res = await this.$axios.post("/api/auth/register", {
                        email: this.form.email.value,
                        phone: this.form.phone.value,
                        name: this.form.name.value,
                        subscribed: this.form.subscribed.value,
                        password: this.form.password.value,
                        tags: tags,
                        // password_confirmation: this.form.password_confirmation.value,
                    });
                    if (res.data.success == false) {
                        this.processError(error);
                    } else {
                        this.$auth
                            .loginWith("cookie", {
                                data: {
                                    email: this.form.email.value,
                                    password: this.form.password.value,
                                },
                            })
                            .then((res) => {
                                if (res.data.success == false) {
                                    this.error = res.data.error;
                                    this.processError(res.data.error);
                                }

                                this.$gtm.push({
                                    event: "GAevent",
                                    eventCategory: "user",
                                    eventAction: "send",
                                    eventLabel: "registration",
                                    userId: res.data.data.retail_id,
                                });
                                if (this.$route.query.redirect === "zakaz") {
                                    this.$router.push("/zakaz");
                                } else {
                                    this.$router.push("/lk/pps-club");
                                }

                                // удаляем из базы ключ устройства
                                this.$grom.removeEvercookieFromServer();
                            })
                            .catch((error) => {
                                this.processError(error);
                            });
                    }
                } catch (error) {
                    this.processError(error);
                }
            });
        },
        processError(error) {
            console.log(`error =>`, error);
            this.isLoading = false;
            if (error.response) {
                if (error.response.status == 406) {
                    let notValidFields = error.response.data.data;
                    for (const key in notValidFields) {
                        if (notValidFields.hasOwnProperty(key)) {
                            const element = notValidFields[key];
                            let name = key.split(".").length > 1 ? key.split(".")[1] : key;
                            if (this.form[name]) {
                                this.form[name].isValid = false;
                                this.form[name].validationMessage = Array.isArray(element) ? element[0] : element;
                            }
                        }
                    }
                    let first_key = Object.keys(notValidFields)[0];
                    let first_name = first_key.split(".").length > 1 ? first_key.split(".")[1] : first_key;
                    let elem = document.querySelector(`[name="${first_name}"]`);
                    if (elem) {
                        elem.scrollIntoView({
                            block: "center",
                            behavior: "smooth",
                        });
                        elem.focus();
                    }
                } else {
                    if (error.response.data.error) {
                        this.error = error.response.data.error;
                    }
                }
            }
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
        this.form.phone.value = this.$auth.loggedIn && this.$auth.user.phone ? this.$auth.user.phone : null;
    },
};
</script>
<style lang="less" scoped>
.login {
    z-index: 1;
    background: #fff;

    &-img {
        img {
            width: 100%;
        }
    }
}

.social-login {
    margin-top: 56px;
}

.login-form {
    padding-top: 40px;
    @media @sm {
        padding-top: 24px;
        padding-bottom: 24px;
    }
}

.login-submit {
    margin-top: 24px;
    margin-bottom: 16px;
    height: 48px;

    .button {
        height: 48px;
    }

    .button--text {
        text-decoration: underline;
        padding: 0 60px;
        margin-left: 16px;
        text-underline-offset: 3px;
        text-decoration-skip: none;
        text-decoration-skip-ink: none;
        @media @sm {
            margin-left: 0;
            margin-top: 8px;
            width: 100%;
        }
    }

    @media @sm {
        height: auto;
        flex-direction: column;
    }
}
</style>
